import React from 'react';
import { Button } from 'zarm';
import classnames from 'classnames';
import { preValidate as onPreValidate } from '@iyunbao/cr-engine';

import { clearObj, clearFunc } from '../../utils/tools';
import { BaseWidgetProps, FetchProps } from '../../utils/type';

export interface ButtonProps extends BaseWidgetProps {
  widget?: 'button' | 'submit' | 'reset';
  hidden?: boolean;
  label: string;
  theme?: 'default' | 'primary' | 'danger';
  block?: boolean;
  size?: 'md' | 'lg' | 'sm' | 'xs';
  fetch?: FetchProps;
  shape?: 'rect' | 'radius' | 'round' | 'circle';
  ghost?: boolean;
  disabled?: boolean;
  className?: string;
  style?: any;
  cascade?: any;
  preValidate?: any;
  type?: string;
  action?: any;
  prefixImg?: string;
  onSubmit?: (props: any, value?: any) => void;
  onLog?: (props: any, value?: any) => void;
  log?: string;
}

function UButton(props: ButtonProps) {
  const {
    type,
    label,
    block,
    style,
    prefixCls = 'crm-button',
    onSubmit,
    className,
    preValidate,
    _crengine,
    action,
    widget = '',
    prefixImg,
    onChange,
    onLog,
    log,
    ...rest
  } = props;
  const { form, path, action: waction } = _crengine || {};

  const cls = classnames(prefixCls, className, {
    [`${prefixCls}-block`]: !!block,
    [`${prefixCls}-prefix`]: !!prefixImg,
  });

  function onAction(value) {
    const { onSubmit: Submit, ...others } = props;

    // 提交类型，部分老项目 用的是widget === 'submit'
    if ((type === 'submit' || widget === 'submit') && form) {
      form.validateFieldsAndScroll((errors, values) => {
        if (errors) {
          return false;
        }

        // 有onLog事件，将onLog事件传递下去
        if (action && waction) {
          if (action.data && onLog) {
            Object.assign(action.data, { onLog });
          }
          // 扩展添加value
          waction(action);
          return false;
        }

        onSubmit && onSubmit(others, values);
      });
      return false;
    }

    // 有onLog事件，将onLog事件传递下去
    if (action && waction) {
      if (action.data && onLog) {
        Object.assign(action.data, { onLog });
      }
      waction(action);
      return false;
    }

    onSubmit && onSubmit(others, value);
  }

  const onClick = () => {
    // 用于埋点标记，回调
    if (log && onLog) {
      onLog && onLog(log);
    }

    // 前置验证
    if (preValidate) {
      const options: any = {
        form,
        path,
      };

      onPreValidate(preValidate, options, (values) => {
        onAction(values);
      });

      return false;
    }

    onAction('');
  };

  const { margin, marginTop, marginLeft, marginRight, marginBottom, width, ...otherStyle } = style || {};
  const renderLabel = () => {
    if (prefixImg) {
      return (
        <div className="prefix-img-wrap">
          <img className="prefix-img-wrap-img" src={prefixImg} alt="" />
          <span>{label}</span>
        </div>
      );
    }

    return label;
  };

  return (
    <div
      className={cls}
      style={clearObj({
        marginTop,
        marginLeft,
        marginRight,
        marginBottom,
        margin,
        width,
      })}
    >
      <Button
        style={clearObj({
          ...otherStyle,
          width: width ? '100%' : undefined,
        })}
        block={block}
        {...clearFunc(rest)}
        onClick={onClick}
      >
        {renderLabel()}
      </Button>
    </div>
  );
}

export default UButton;
